import styled from "styled-components";
import TextFieldStyles from "../TextField/styles";

const Styles = styled(TextFieldStyles)``;

export default Styles;
